<template>
  <div>
   <div class="fixed z-50 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
​
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
​
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-md w-full">
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start">
            <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
              <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                {{include_message}} Evidence
              </h3>
              <div class="mt-1">
                <p class="text-sm sm:text-base text-gray-500">
                  Do you really want to {{include_message}} it?
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2">
            <div id="tabs-1-panel-1" class="p-4 -m-0.5 rounded-lg" aria-labelledby="tabs-1-tab-1" role="tabpanel" tabindex="0">
                <label for="comment" class="sr-only">Comment</label>
                <div>
                <textarea maxlength="500" v-model="comment" rows="5" name="comment" id="comment" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="Add your comment..."></textarea>
                </div>
            </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse">
          <button @click="deleteTheEvidence()" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto text-sm">
            {{include_message}}
          </button>
          <button @click="closeDeleteEvidenceModal()" type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:mt-0 sm:ml-3 sm:w-auto text-sm">
            Cancel
          </button>
        </div>
      </div>
    </div>
</div>
</div>
</template>

<script>
// import { apiUrl } from '../../config/base';
import ProtestRequestApi from "../../services/api/AdminProtestRequest";
export default {
props :["evidence_image_uid","include_message"],
  components: {

  },
  data() {
    return {
        // url:apiUrl,
        comment:'',
    };
  },
  created(){
  },
  methods: {
      closeDeleteEvidenceModal(){
          this.$emit('close-delete-evidence-modal',{'delete':false});
      },
      deleteTheEvidence(){
         if(this.comment == '') {
          this.$toast.open('Please fill the reason');
          return;
        }

        if(this.comment.length > 500) {
          this.$toast.open('Maximum character allowed in comment is 500');
          return;
        }

        
          ProtestRequestApi.deleteEvidenceImage(
            this.evidence_image_uid,
            this.comment
          ).then((res) => {
            this.$toast.open('Evidence excluded');
            this.$emit('close-delete-evidence-modal',{'delete':true,'image_uid':this.evidence_image_uid,'comment':this.comment});
          }).catch(function(error) {
            throw new Error(error);
          });



      }

  }
};
</script>

<style scoped>
</style>
